<ul class="flex flex-col list-none gap-1 p-2.5 m-0 pb-0">
    @for (permission of permissionLabels(); track permission) {
        <li>
            <span class="text-base font-normal">{{ permission | transloco }}</span>
        </li>
    } @empty {
        <li class="flex p-2">
            <span>-</span>
        </li>
    }
</ul>
